
import React from "react";
import NavLink from "./navlink";

const DesktopTopbar = ({ links }) => {
  return (
    <nav className="hidden md:flex items-center gap-5 lg:gap-7 text-sm">
      {links.map((item) => (
        <NavLink
          target={item.target}
          key={item.target}
          className="text-slate-300 hover:text-white transition-colors duration-200"
        >
          {item.title}
        </NavLink>
      ))}
      <NavLink target="contact" className="btn-primary !py-2 !px-4">
        Kontakt
      </NavLink>
    </nav>
  );
};

export default DesktopTopbar;
